import React, { createContext, useContext, useState, useEffect } from 'react';
import es from '../translations/es.json';
import en from '../translations/en.json';
import { useAuthStore } from '../store/useAuthStore';
import api from '../api.js';

const translations = { es, en };

const IdiomaContext = createContext();

export const IdiomaProvider = ({ children }) => {
  const usuario = useAuthStore(state => state.user);
  const [idioma, setIdiomaState] = useState(localStorage.getItem('dayflow-lang') || 'es');

  useEffect(() => {
    if (usuario && usuario.idioma && usuario.idioma !== idioma) {
      setIdiomaState(usuario.idioma);
      localStorage.setItem('dayflow-lang', usuario.idioma);
    }
  }, [usuario, idioma]);

  const setIdioma = async (nuevoIdioma) => {
    setIdiomaState(nuevoIdioma);
    localStorage.setItem('dayflow-lang', nuevoIdioma);
    if (usuario) {
      try {
        await api.actualizarPerfil({ idioma: nuevoIdioma });
        // update the local user model state so it remains consistent
        usuario.idioma = nuevoIdioma;
      } catch (err) {
        console.error('Error updating language in backend:', err);
      }
    }
  };

  const t = (path) => {
    const keys = path.split('.');
    let result = translations[idioma];
    for (const key of keys) {
      if (result[key]) {
        result = result[key];
      } else {
        return path; // Fallback al path si no existe
      }
    }
    return result;
  };

  return (
    <IdiomaContext.Provider value={{ idioma, setIdioma, t }}>
      {children}
    </IdiomaContext.Provider>
  );
};

export const useIdioma = () => {
  const context = useContext(IdiomaContext);
  if (!context) {
    throw new Error('useIdioma debe usarse dentro de un IdiomaProvider');
  }
  return context;
};
